exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".day[data-v-33665bee]{min-height:100px;position:relative}.today[data-v-33665bee]{color:#ffde03}.sunday[data-v-33665bee]{color:red}.review-count[data-v-33665bee]{position:absolute;top:0;right:0;background:rgba(0,0,0,.1);padding:5px;border-radius:3px}", ""]);

// exports
